export function getContentId(data, chosenData, code){   
    if(data.enableProductOptions && chosenData && chosenData[code] && chosenData[code] != ""){
        return chosenData[code]
    }else if(data[code] && data[code] != ""){
        return data[code];
    }

    return data._id;
}